var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgUnreadIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 17.423,
    height: 15.681,
    viewBox: "0 0 17.423 15.681",
    fill: "",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Path_6455",
    "data-name": "Path 6455",
    d: "M16.81,8.969a4.338,4.338,0,0,0,2.613-.889v7.858a1.747,1.747,0,0,1-1.742,1.742H3.742A1.747,1.747,0,0,1,2,15.938V5.485A1.747,1.747,0,0,1,3.742,3.742h8.8a4.764,4.764,0,0,0-.087.871,4.332,4.332,0,0,0,1.455,3.232l-3.2,1.995L4.875,6.19a.74.74,0,1,0-.784,1.254L10.25,11.3a.881.881,0,0,0,.923,0l4.155-2.6A4.418,4.418,0,0,0,16.81,8.969ZM14.2,4.613A2.613,2.613,0,1,0,16.81,2,2.61,2.61,0,0,0,14.2,4.613Z",
    transform: "translate(-2 -2)"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUnreadIcon);
export default __webpack_public_path__ + "static/media/unreadIcon.5ff34c3da99ec62c2459d69e76166b58.svg";
export { ForwardRef as ReactComponent };